"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var bottom_sheet_1 = require("@angular/material/bottom-sheet");
var InformationSheetComponent = /** @class */ (function () {
    function InformationSheetComponent(bottomSheet, data) {
        this.bottomSheet = bottomSheet;
        this.data = data;
        this._message = "";
        this.message = data.message;
    }
    Object.defineProperty(InformationSheetComponent.prototype, "message", {
        get: function () {
            return this._message;
        },
        set: function (message) {
            this._message = (message && message.trim()) || "";
        },
        enumerable: true,
        configurable: true
    });
    InformationSheetComponent.prototype.ngOnInit = function () { };
    return InformationSheetComponent;
}());
exports.InformationSheetComponent = InformationSheetComponent;
